import React, { useEffect, useState } from "react";
import PersonIcon from "@material-ui/icons/Person";
import { connect } from "react-redux";
import flowchart from "../../../pdf/Flowchart.pdf";
import FlowchartStep1 from "../../../pdf/FlowchartStep1.pdf";
import exampleFormStepOne from "../../../pdf/exampleFormStepOne.pdf";
import petitioner_basic from "../../../pdf/petitioner_basic.pdf";
import petitioner_simple from "../../../pdf/petitioner_simple.pdf";
import petitioner_simple_plus from "../../../pdf/petitioner_simple_plus.pdf";
import respondant_basic from "../../../pdf/respondant_basic.pdf";
import respondant_simple from "../../../pdf/respondant_simple.pdf";
import respondant_simple_plus from "../../../pdf/respondant_simple_plus.pdf";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import ListAltIcon from "@material-ui/icons/ListAlt";
import PetitionerPaid from "../../../pdf/paidPetitioner.pdf";
import paidRespondent from "../../../pdf/paidRespondent.pdf";
import freeSampleForms from "../../../pdf/freeSampleForms.pdf";
import {
  maritalSettlementGetAllData,
} from "../forms/maritalSettlementAgreements/maritalSettlement.action";
import {
  getAllData as getAllDataChild
} from "../forms/childInformation/ChildInformationAction";
import {
  allAssetDebitData
} from "../forms/disclosure/property/assestDebit/assestDebit.actions";
import {
  getFormData
} from "../forms/profileInformation/profileInformation.actions";
import {
  getFormData as getAllDataPetition
} from "../forms/PetitionerPacket.actions.js";
import {
  getRespondentFormData
} from "../forms/responsePacket.actions.js";
import {
  getCourtFormData
} from "../forms/servingCourt.actions.js";
import {
  getAllFormData as getAllFormDataAcknow
} from "../forms/disclosure/acknowledgement/acknowledgement.actions";
import {
  getData as getData142
} from "../forms/disclosure/fl-142/FL142.actions";
import {
  getData as getDataCommunity
} from "../forms/disclosure/property/community-property/communityProperty.actions";
import {
  getData as getDataSeparate
} from "../forms/disclosure/property/separate-property/separateProperty.actions";
import {
  getJudgementFormData
} from "../forms/completeDivorceJudgement/judgmentPacketForms/judgementPacketForms.actions";
import {
  getChildSupport
} from "../forms/completeDivorceJudgement/childSupportInformation/childSupportInformation.actions";
import {
  childSupportGetAllData as nonChildSupportGetAllData
} from "../forms/nonGuideLineChildSupport/NonGuideLine.actions"

import {
  Button,
  Row,
  Col,
  Card,
  Container,
  CardTitle,
} from "reactstrap";
import Typography from "@material-ui/core/Typography";

const Introduction = (props, state) => {
  useEffect(() => {
    props.maritalSettlementGetAllData({
      divorce_id: window.localStorage.getItem("divorce_id")
    });

    props.getAllDataChild({
      divorce_id: window.localStorage.getItem("divorce_id"),
    });

    props.allAssetDebitData({
      divorce_id: window.localStorage.getItem("divorce_id"),
    });

    props.getFormData({
      divorce_id: window.localStorage.getItem("divorce_id"),
    });
    props.getAllDataPetition({
      divorce_id: window.localStorage.getItem("divorce_id"),
    });
    props.getRespondentFormData({
      divorce_id: window.localStorage.getItem("divorce_id"),
    });

    props.getCourtFormData({
      divorce_id: window.localStorage.getItem("divorce_id"),
    });

    props.getAllFormDataAcknow({
      divorce_id: window.localStorage.getItem("divorce_id"),
    });
    props.getData142({
      divorce_id: window.localStorage.getItem("divorce_id"),
    });
    props.getDataCommunity({
      divorce_id: window.localStorage.getItem("divorce_id"),
    });
    props.getDataSeparate({
      divorce_id: window.localStorage.getItem("divorce_id"),
    });
    props.getJudgementFormData({
      divorce_id: window.localStorage.getItem("divorce_id"),
    });
    props.getChildSupport({
      divorce_id: window.localStorage.getItem("divorce_id"),
    });
    props.nonChildSupportGetAllData({
      divorce_id: window.localStorage.getItem("divorce_id"),
    });


  }, []);
  let type = 1;

  return (
    <div
      style={{
        fontStyle: "normal",
        fontFamily: "sans-serif",
        backgroundColor: "white",
        textAlign: "justify",
        textJustify: "inter-word",
        padding: "30px 70px"
      }}
    >
      <h1
        style={{
          fontFamily: "san-serif",
          fontWeight: "800",
          marginBottom: "25px",
          textAlign: "center"
        }}
      >
        INTRODUCTION
      </h1>
      <Typography
        style={{ fontFamily: "san-serif", marginBottom: "15px", fontSize: "20px" }}
      >
        Welcome to TCD Form Builder. You will find each of the divorce steps in
        the menu column. The forms you need are linked within each step. If you
        wish to use the form builder, use the questionnaire in each step to have
        the forms auto filled with what you provide. The questionnaire is not
        meant to collect all your information to complete the forms. They also
        can be edited until you are ready to finalize and download your forms
        giving you the most flexibility. Please use all tools, including video
        instructions and example forms, provided to prevent your documents from
        being rejected by the court clerk.
      </Typography>
      <Container>
        <Row>
          {/* First Card */}
          <Col sm="12">
            <Card
              body
              style={{ fontFamily: "Lobster cursive", color: "#118eac" }}
            >
              <h4
                style={{
                  textAlign: "center",
                  color: "red",
                  fontWeight: "800",
                }}
              >
              </h4>
              <Card body style={{ marginBottom: "6px" }}>
                <CardTitle tag="h5">
                  <PersonIcon style={{ marginRight: "8px" }} />
                  Petitioner's Checklist
                  <a
                    style={{ textDecoration: "none" }}
                    href={(localStorage.getItem("up") == '1' || localStorage.getItem("up") == '3') ? (type === 1 ? petitioner_basic : type === 2 ? petitioner_simple : petitioner_simple_plus) : PetitionerPaid}
                    target="_blank"
                  >
                    <Button outline color="primary" style={{ float: "right" }}>
                      Download
                    </Button>
                  </a>
                </CardTitle>
              </Card>
              <Card body style={{ marginBottom: '6px' }}>
                <CardTitle tag="h5">
                  <PersonIcon style={{ marginRight: "8px" }} />
                  Respondent's Checklist
                  <a
                    style={{ textDecoration: "none" }}
                    href={(localStorage.getItem("up") == '1' || localStorage.getItem("up") == '3') ? (type === 1 ? respondant_basic : type === 2 ? respondant_simple : respondant_simple_plus) : paidRespondent}
                    target="_blank"
                  >
                    <Button outline color="primary" style={{ float: "right" }}>
                      Download
                    </Button>
                  </a>
                </CardTitle>
              </Card>
              <Card body style={{ marginBottom: "6px" }}>
                <CardTitle tag="h5">
                  <EqualizerIcon style={{ marginRight: "6px" }} />
                  Flowchart
                  <a
                    style={{ textDecoration: "none" }}
                    href={(localStorage.getItem("up") == '1' || localStorage.getItem("up") == '3') ? FlowchartStep1 : flowchart}
                    target="_blank"
                  >
                    <Button outline color="primary" style={{ float: "right" }}>
                      Download
                    </Button>
                  </a>
                </CardTitle>
              </Card>
              <Card body style={{ marginBottom: "6px" }}>
                <CardTitle tag="h5">
                  <ListAltIcon style={{ marginRight: "4px" }} />
                  Sample Forms
                  <a
                    style={{ textDecoration: "none" }}
                    href={(localStorage.getItem("up") == '1' || localStorage.getItem("up") == '3') ? exampleFormStepOne : freeSampleForms}
                    target="_blank"
                  >
                    <Button outline color="primary" style={{ float: "right" }}>
                      Download
                    </Button>
                  </a>
                </CardTitle>
              </Card>
            </Card>
          </Col>


        </Row>
      </Container>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getAllDataChild: (data) => dispatch(getAllDataChild(data)),
  getFormData: (data) => dispatch(getFormData(data)),

  getAllDataPetition: (data) => dispatch(getAllDataPetition(data)),
  getRespondentFormData: (data) => dispatch(getRespondentFormData(data)),
  getCourtFormData: (data) => dispatch(getCourtFormData(data)),

  allAssetDebitData: (data) => dispatch(allAssetDebitData(data)),
  getAllFormDataAcknow: (data) => dispatch(getAllFormDataAcknow(data)),
  getData142: (data) => dispatch(getData142(data)),
  getDataCommunity: (data) => dispatch(getDataCommunity(data)),
  getDataSeparate: (data) => dispatch(getDataSeparate(data)),

  getJudgementFormData: (data) => dispatch(getJudgementFormData(data)),
  getChildSupport: (data) => dispatch(getChildSupport(data)),
  nonChildSupportGetAllData: (data) => dispatch(nonChildSupportGetAllData(data)),
  maritalSettlementGetAllData: (data) => dispatch(maritalSettlementGetAllData(data)),
});


const mapStateToProps = (state, ownProps, number) => ({
  userPackage: state.userAccountReducer.userPackage,

});

export default connect(mapStateToProps, mapDispatchToProps)(Introduction);
